"use client";
import * as React from "react";
import { Input } from "@/components/ui/input";
import { useListContext } from "react-admin";
import { DataTable } from "../data-table/data-table";
import { Button } from "../ui/button";
import { exportTable } from "@/utils/download";

interface Props {
  columns: any[];
  filterSearch: string;
  create?: React.ReactNode;
  anotherButton?: React.ReactNode;
  rowClick?: Function;
  useListContextFilter?: boolean;
  isExportButton?: boolean;
  renderToolbarFilters?: (table: any) => React.ReactNode;
}

const CommonTableList: React.FC<Props> = ({
  columns,
  filterSearch,
  create,
  anotherButton,
  rowClick,
  useListContextFilter = false,
  isExportButton = false,
  renderToolbarFilters
}) => {
  const {
    data = [],
    total = 0,
    page = 1,
    perPage = 10,
    setPage,
    setPerPage,
    setFilters,
    filterValues,
    sort,
    setSort,
  } = useListContext();

  const handleDetailClick = (row: any) => {
    if (rowClick) {
      
      rowClick(row);
    }
  };

  return (
    <DataTable
      data={data}
      columns={columns}
      filterSearch={filterSearch}
      // isCustomFiltered={
      //   statusFilter.length > 0 ||
      //   filteredVehicles.length > 0 ||
      //   clientFilter?.length > 0 ||
      //   pickupFilter?.length > 0 ||
      //   filteredDrivers?.length > 0
      // }
      pagination={{
        page,
        perPage,
        setPage,
        setPerPage,
        total,
      }}
      sorting={{
        sort,
        setSort,
      }}
      onRowClick={handleDetailClick}
      renderToolbarFilters={renderToolbarFilters}
      // onResetFilters={handleResetFilters}
      rightActions={
        <>
          {create}
          {anotherButton}
          {isExportButton && <Button onClick={() => exportTable(columns, data)}>Export</Button>}
        </>
      }
    />
  );
};

export default CommonTableList;
